// extracted by mini-css-extract-plugin
module.exports = {"actions":"DialogBox_actions__21yAb","button":"DialogBox_button__13pxA"};